<template>
  <div class="page-container">
    <h1 class="page-title">{{ t('pages.news.company.news.title') }}</h1>

   <div class="partner-grid-container">
      <!-- 合作伙伴网格 - 静态展示 -->
      <div  class="partner-grid">
        <template v-for="(companynew, index) in companynewsList" :key="index">
          <a v-if="companynew.url" :href="getUrlWithLang(companynew.url)" @click.prevent="handleClick(companynew.url)" class="partner-card-link">
            <div class="partner-card">
              <div class="image-container">
                         <img :src="companynew.image">

              </div>
              <div class="partner-info">
                <div class="partner-name">
                  {{ companynew.title }}<br>
                  {{ companynew.date }}
                </div>
                <!-- <div class="partner-date" v-if="companynew.date">{{ formatDate(companynew.date) }}</div> -->
              </div>
            </div>
          </a>
        </template>
      </div>
    </div>
  </div>
   
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
// 导入模块
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';
import { useLangStore } from '../../../pinia/stores/lang';

const { t } = useI18n();
const langStore = useLangStore();
const router = useRouter();
const handleClick = (url: string) => {
  router.push(url);
  
};

// 日期格式化函数
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 生成包含语言参数的URL
const getUrlWithLang = (originalUrl: string) => {
  if (!originalUrl) return originalUrl;

  const currentLang = langStore.currentLang.startsWith('zh') ? 'zh' : 'en';
  const separator = originalUrl.includes('?') ? '&' : '?';
  return `${originalUrl}${separator}lang=${currentLang}`;
};

// 根据当前语言选择对应的翻译数据
const translationData = computed(() => {
  console.log('当前语言:', langStore.currentLang);
  return langStore.currentLang.startsWith('zh') ? zhData : enData;
});


const companynewsList = computed(() => {
  const data = translationData.value.pages.news.company.news.list;
  const filteredData = data.filter((item: any) => item && typeof item === 'object' && Object.keys(item).length > 0);
  
  // 根据语言过滤新闻 - 某些新闻只在中文版显示
  const currentLang = langStore.currentLang.startsWith('zh') ? 'zh' : 'en';
  const languageFilteredData = filteredData.filter((item: any) => {
    // 如果新闻项有 onlyInChinese 标记且当前是英文版，则过滤掉
    if (item.onlyInChinese && currentLang === 'en') {
      return false;
    }
    return true;
  });
  
  // 按日期排序（最新的在前）
  return languageFilteredData.sort((a: any, b: any) => {
    if (!a.date || !b.date) return 0;
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });
});
</script>

<style scoped lang="scss">
// 页面特定样式
.page-container {
  padding-bottom: 60px;
}

.page-subtitle {
  text-align: center;
  margin: -20px auto 30px;
  color: #666;
  font-size: 16px;
  max-width: 800px;
}

.companynews-description {
  margin: 0 auto 40px;
  max-width: 1000px;
  text-align: justify;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  padding: 0 20px;
}


.companynews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 25px;
}

.companynew-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  }
  
  .image-container {
    height: 160px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  
  .companynew-info {
    padding: 15px;
    
    .companynew-title {
      font-size: 15px;
      font-weight: 500;
      color: #333;
      margin-bottom: 5px;
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 40px;
    }
  }
}



.page-container {
  padding-bottom: 60px;
}

.page-subtitle {
  text-align: center;
  margin: -20px auto 30px;
  color: #666;
  font-size: 16px;
  max-width: 800px;
}

.carousel-container {
  height: 70vh; // 设置轮播容器高度
  margin-top: 30px;
}

.layout-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  .switch-control {
    :deep(.el-switch__label) {
      color: #666;
    }
  }
}

.partner-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  
  .partner-card {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    }
  }
}

.partner-grid-container .partner-grid{
  grid-template-columns: repeat(3, 1fr);
}
.partner-grid-container{
 height: calc(100vh - 400px);
}
// 响应式优化
@media screen and (max-width: 768px) {
  .page-container {
    padding: 60px 20px 20px; 
    margin: 0 auto;
    max-width: 600px; // 限制最大宽度让内容居中
  }

  .page-subtitle {
    font-size: 14px;
    margin: -15px auto 25px;
  }
  
  .carousel-container {
    height: 60vh;
  }

  .partner-grid-container .partner-grid {
    grid-template-columns: 1fr; // 移动端一行一个
  }

  // .partner-card {
  //   max-width: 100%;
  //   margin: 0 auto;
  // }
}
</style>